import { createGlobalStyle } from 'styled-components';

const StepThreeStyles = createGlobalStyle`
.step3-page {
  background: #f6f6f6;
  height: 100%;
  overflow-y: auto;
}
.step3-page .container-fluid {
  position: relative;
  min-height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
}

.step3-page .container-fluid .main-content {
  flex: 1;
  margin-top: 32px;
  padding: 0px 6px;
}

.step3-page .container-fluid .main-content .message {
  margin: auto;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #6f7072;
}

.step3-page .container-fluid .main-content .live-camera {
  width: 100%;
  height: 0%;
  padding-top: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px auto;
  position: relative;
  overflow: hidden;
}
.step3-page .container-fluid .main-content .live-camera .live-camera-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.step3-page .container-fluid .main-content .live-camera .camera-loading {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: url("images/camera-loading.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  animation: loading 2s linear infinite;
  z-index: 1;
}
.step3-page .container-fluid .main-content .live-camera .camera-wp {
  background: #ffffff;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  padding: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.step3-page .container-fluid .main-content .live-camera .camera-wp img {
  width: calc(100% - 16px);
  height: calc(100% - 16px);
  object-fit: cover;
  padding: 8px;
  border-radius: 50%;
  background: transparent;
}

.step3-page .container-fluid .main-content .btns-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 24px;
}

.step3-page .container-fluid .main-content .btns-section button a {
  display: block;
  width: 100%;
  height: 100%;
}
.step3-page .container-fluid .main-content .btns-section button a:hover,
.step3-page .container-fluid .main-content .btns-section button a:focus:active {
  text-decoration: none;
}

.step3-page .container-fluid .main-content .btns-section .error-message {
  background: rgba(243, 49, 58, 0.2);
  border-radius: 12px;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 12px;
  gap: 16px;
  width: 335px;
  color: #c21b17;
  display: none;
}

.step3-page .container-fluid .main-content .btns-section.error .btn {
  display: none;
}
.step3-page .container-fluid .main-content .btns-section.error .error-message {
  display: flex;
}
.step3-page .container-fluid .main-content .btns-section .error-message .icon {
  color: #c21b17;
}

.step3-page .container-fluid .main-content .btns-section .error-message p {
  margin: 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

@media screen and (min-width: 576px) {
  .step3-page .container-fluid .main-content .live-camera {
    width: 500px;
    padding-top: 500px;
  }
}

@media screen and (min-width: 769px) {
  .step3-page .container-fluid {
    min-height: calc(100% - 60px);
  }

  .step3-page .container-fluid .main-content {
    background: #ffffff;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.02), 0px 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 32px 32px 0px 0px;
    padding: 24px;
  }

  .step3-page .container-fluid .main-content .message {
    margin: auto;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: #6f7072;
  }

  .step3-page .container-fluid .main-content .live-camera {
    width: 392px;
    padding-top: 392px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px auto;
    position: relative;
  }
  .live-camera .camera-loading {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url("images/camera-loading.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    animation: loading 2s linear infinite;
  }
  .step3-page .container-fluid .main-content .live-camera .camera-wp img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .step3-page .container-fluid .main-content .btns-section {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 24px;
  }

  .step3-page .container-fluid .main-content .btns-section .error-message {
    background: rgba(243, 49, 58, 0.2);
    border-radius: 12px;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 12px;
    gap: 16px;
    width: 335px;
    color: #c21b17;
    display: none;
  }

  .step3-page .container-fluid .main-content .btns-section.error .btn {
    display: none;
  }
  .step3-page
    .container-fluid
    .main-content
    .btns-section.error
    .error-message {
    display: flex;
  }
  .step3-page
    .container-fluid
    .main-content
    .btns-section
    .error-message
    .icon {
    color: #c21b17;
  }

  .step3-page .container-fluid .main-content .btns-section .error-message p {
    margin: 0;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
}

@media screen and (max-width: 768px) {
  .step3-page > .container-fluid {
    padding: 0;
  }
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

`;

export default StepThreeStyles;
